__webpack_require__.p = "https://bmidxbindiaplprod.netlify.app/";